(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Bitakore-common'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Bitakore-common'.");
    }
    globalThis['Bitakore-common'] = factory(typeof globalThis['Bitakore-common'] === 'undefined' ? {} : globalThis['Bitakore-common'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var Enum = kotlin_kotlin.$_$.lc;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var VOID = kotlin_kotlin.$_$.b;
  var THROW_IAE = kotlin_kotlin.$_$.uc;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ActivityCategory, 'ActivityCategory', VOID, Enum);
  initMetadataForClass(ActivityType, 'ActivityType', VOID, Enum);
  initMetadataForClass(BitacoraEntryStatus, 'BitacoraEntryStatus', VOID, Enum);
  initMetadataForClass(ClaimDecision, 'ClaimDecision', VOID, Enum);
  initMetadataForClass(VerificationDecision, 'VerificationDecision', VOID, Enum);
  initMetadataForClass(VisibilityDecision, 'VisibilityDecision', VOID, Enum);
  initMetadataForClass(CompanyMemberRole, 'CompanyMemberRole', VOID, Enum);
  initMetadataForClass(CompanyType, 'CompanyType', VOID, Enum);
  //endregion
  var ActivityCategory_AVIATION_instance;
  var ActivityCategory_AIR_SPORTS_instance;
  var ActivityCategory_UNDERWATER_instance;
  var ActivityCategory_MARITIME_instance;
  var ActivityCategory_MOUNTAIN_instance;
  var ActivityCategory_HEAVY_MACHINERY_instance;
  var ActivityCategory_TECHNICAL_TRADES_instance;
  var ActivityCategory_ATHLETICS_instance;
  var ActivityCategory_ANIMAL_HANDLING_instance;
  var ActivityCategory_VOCATIONAL_instance;
  var ActivityCategory_RECREATIONAL_SPORTS_instance;
  var ActivityCategory_TABLETOP_GAMES_instance;
  var ActivityCategory_MOTORSPORTS_instance;
  var ActivityCategory_entriesInitialized;
  function ActivityCategory_initEntries() {
    if (ActivityCategory_entriesInitialized)
      return Unit_instance;
    ActivityCategory_entriesInitialized = true;
    ActivityCategory_AVIATION_instance = new ActivityCategory('AVIATION', 0);
    ActivityCategory_AIR_SPORTS_instance = new ActivityCategory('AIR_SPORTS', 1);
    ActivityCategory_UNDERWATER_instance = new ActivityCategory('UNDERWATER', 2);
    ActivityCategory_MARITIME_instance = new ActivityCategory('MARITIME', 3);
    ActivityCategory_MOUNTAIN_instance = new ActivityCategory('MOUNTAIN', 4);
    ActivityCategory_HEAVY_MACHINERY_instance = new ActivityCategory('HEAVY_MACHINERY', 5);
    ActivityCategory_TECHNICAL_TRADES_instance = new ActivityCategory('TECHNICAL_TRADES', 6);
    ActivityCategory_ATHLETICS_instance = new ActivityCategory('ATHLETICS', 7);
    ActivityCategory_ANIMAL_HANDLING_instance = new ActivityCategory('ANIMAL_HANDLING', 8);
    ActivityCategory_VOCATIONAL_instance = new ActivityCategory('VOCATIONAL', 9);
    ActivityCategory_RECREATIONAL_SPORTS_instance = new ActivityCategory('RECREATIONAL_SPORTS', 10);
    ActivityCategory_TABLETOP_GAMES_instance = new ActivityCategory('TABLETOP_GAMES', 11);
    ActivityCategory_MOTORSPORTS_instance = new ActivityCategory('MOTORSPORTS', 12);
  }
  function ActivityCategory(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ActivityCategory_AVIATION_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_AVIATION_instance;
  }
  function ActivityCategory_AIR_SPORTS_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_AIR_SPORTS_instance;
  }
  function ActivityCategory_UNDERWATER_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_UNDERWATER_instance;
  }
  function ActivityCategory_MARITIME_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_MARITIME_instance;
  }
  function ActivityCategory_MOUNTAIN_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_MOUNTAIN_instance;
  }
  function ActivityCategory_HEAVY_MACHINERY_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_HEAVY_MACHINERY_instance;
  }
  function ActivityCategory_TECHNICAL_TRADES_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_TECHNICAL_TRADES_instance;
  }
  function ActivityCategory_ATHLETICS_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_ATHLETICS_instance;
  }
  function ActivityCategory_ANIMAL_HANDLING_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_ANIMAL_HANDLING_instance;
  }
  function ActivityCategory_VOCATIONAL_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_VOCATIONAL_instance;
  }
  function ActivityCategory_RECREATIONAL_SPORTS_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_RECREATIONAL_SPORTS_instance;
  }
  function ActivityCategory_TABLETOP_GAMES_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_TABLETOP_GAMES_instance;
  }
  function ActivityCategory_MOTORSPORTS_getInstance() {
    ActivityCategory_initEntries();
    return ActivityCategory_MOTORSPORTS_instance;
  }
  var ActivityType_STUDENT_PILOT_instance;
  var ActivityType_AIRLINE_TRANSPORT_PILOT_instance;
  var ActivityType_FLIGHT_INSTRUCTOR_instance;
  var ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_instance;
  var ActivityType_DRONE_OPERATOR_instance;
  var ActivityType_GLIDER_PILOT_instance;
  var ActivityType_HOT_AIR_BALLOON_PILOT_instance;
  var ActivityType_FLIGHT_SIMULATOR_OPERATOR_instance;
  var ActivityType_ASTRONAUT_instance;
  var ActivityType_AEROBATIC_PILOT_instance;
  var ActivityType_PARACHUTE_RIGGER_instance;
  var ActivityType_SKYDIVER_instance;
  var ActivityType_PARAGLIDER_instance;
  var ActivityType_HANG_GLIDER_instance;
  var ActivityType_BASE_JUMPER_instance;
  var ActivityType_PARAMOTOR_PILOT_instance;
  var ActivityType_SPEEDWING_FLYER_instance;
  var ActivityType_WINGSUIT_PILOT_instance;
  var ActivityType_INDOOR_SKYDIVING_COACH_instance;
  var ActivityType_RECREATIONAL_SCUBA_DIVER_instance;
  var ActivityType_TECHNICAL_DIVER_instance;
  var ActivityType_COMMERCIAL_DIVER_instance;
  var ActivityType_SCIENTIFIC_RESEARCH_DIVER_instance;
  var ActivityType_FREEDIVER_instance;
  var ActivityType_PUBLIC_SAFETY_DIVER_instance;
  var ActivityType_SPEARFISHING_DIVER_instance;
  var ActivityType_UNDERWATER_PHOTOGRAPHER_instance;
  var ActivityType_MERCHANT_MARINE_instance;
  var ActivityType_SAILING_CAPTAIN_instance;
  var ActivityType_WHITEWATER_GUIDE_instance;
  var ActivityType_LIFEGUARD_instance;
  var ActivityType_ROWING_ATHLETE_instance;
  var ActivityType_SURFER_instance;
  var ActivityType_KITESURFER_instance;
  var ActivityType_ALPINE_MOUNTAINEER_instance;
  var ActivityType_ROCK_CLIMBER_instance;
  var ActivityType_ICE_CLIMBER_instance;
  var ActivityType_SPELUNKER_instance;
  var ActivityType_THRU_HIKER_instance;
  var ActivityType_CANYONEER_instance;
  var ActivityType_BACKCOUNTRY_SKIER_instance;
  var ActivityType_CDL_TRUCK_DRIVER_instance;
  var ActivityType_TRANSIT_OPERATOR_instance;
  var ActivityType_CRANE_OPERATOR_instance;
  var ActivityType_FORKLIFT_OPERATOR_instance;
  var ActivityType_RAILWAY_CONDUCTOR_instance;
  var ActivityType_HEAVY_EQUIPMENT_OPERATOR_instance;
  var ActivityType_LAB_RESEARCHER_instance;
  var ActivityType_HAM_RADIO_OPERATOR_instance;
  var ActivityType_ENVIRONMENTAL_FIELD_CREW_instance;
  var ActivityType_SOFTWARE_QA_ENGINEER_instance;
  var ActivityType_SOUND_ENGINEER_instance;
  var ActivityType_LAND_SURVEYOR_instance;
  var ActivityType_POWERLIFTER_instance;
  var ActivityType_TRAIL_RUNNER_instance;
  var ActivityType_TRIATHLETE_instance;
  var ActivityType_PHYSICAL_THERAPY_PATIENT_instance;
  var ActivityType_TRACK_AND_FIELD_THROWER_instance;
  var ActivityType_COMPETITIVE_CYCLIST_instance;
  var ActivityType_COMPETITIVE_SWIMMER_instance;
  var ActivityType_EQUESTRIAN_instance;
  var ActivityType_WORKING_DOG_HANDLER_instance;
  var ActivityType_FALCONER_instance;
  var ActivityType_BEEKEEPER_instance;
  var ActivityType_LIVESTOCK_HANDLER_instance;
  var ActivityType_TATTOO_APPRENTICE_instance;
  var ActivityType_TRADE_APPRENTICE_instance;
  var ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_instance;
  var ActivityType_WELDING_APPRENTICE_instance;
  var ActivityType_CULINARY_APPRENTICE_instance;
  var ActivityType_WALKER_instance;
  var ActivityType_RUNNER_instance;
  var ActivityType_RAFTER_instance;
  var ActivityType_GOLFER_instance;
  var ActivityType_DARTS_PLAYER_instance;
  var ActivityType_BASEBALL_PLAYER_instance;
  var ActivityType_BILLIARDS_PLAYER_instance;
  var ActivityType_ALPINE_SKIER_instance;
  var ActivityType_DOWNHILL_MOUNTAIN_BIKER_instance;
  var ActivityType_YOGA_PRACTITIONER_instance;
  var ActivityType_CARD_PLAYER_instance;
  var ActivityType_RACE_CAR_DRIVER_instance;
  var ActivityType_MOTORCYCLE_RIDER_instance;
  function values() {
    return [ActivityType_STUDENT_PILOT_getInstance(), ActivityType_AIRLINE_TRANSPORT_PILOT_getInstance(), ActivityType_FLIGHT_INSTRUCTOR_getInstance(), ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_getInstance(), ActivityType_DRONE_OPERATOR_getInstance(), ActivityType_GLIDER_PILOT_getInstance(), ActivityType_HOT_AIR_BALLOON_PILOT_getInstance(), ActivityType_FLIGHT_SIMULATOR_OPERATOR_getInstance(), ActivityType_ASTRONAUT_getInstance(), ActivityType_AEROBATIC_PILOT_getInstance(), ActivityType_PARACHUTE_RIGGER_getInstance(), ActivityType_SKYDIVER_getInstance(), ActivityType_PARAGLIDER_getInstance(), ActivityType_HANG_GLIDER_getInstance(), ActivityType_BASE_JUMPER_getInstance(), ActivityType_PARAMOTOR_PILOT_getInstance(), ActivityType_SPEEDWING_FLYER_getInstance(), ActivityType_WINGSUIT_PILOT_getInstance(), ActivityType_INDOOR_SKYDIVING_COACH_getInstance(), ActivityType_RECREATIONAL_SCUBA_DIVER_getInstance(), ActivityType_TECHNICAL_DIVER_getInstance(), ActivityType_COMMERCIAL_DIVER_getInstance(), ActivityType_SCIENTIFIC_RESEARCH_DIVER_getInstance(), ActivityType_FREEDIVER_getInstance(), ActivityType_PUBLIC_SAFETY_DIVER_getInstance(), ActivityType_SPEARFISHING_DIVER_getInstance(), ActivityType_UNDERWATER_PHOTOGRAPHER_getInstance(), ActivityType_MERCHANT_MARINE_getInstance(), ActivityType_SAILING_CAPTAIN_getInstance(), ActivityType_WHITEWATER_GUIDE_getInstance(), ActivityType_LIFEGUARD_getInstance(), ActivityType_ROWING_ATHLETE_getInstance(), ActivityType_SURFER_getInstance(), ActivityType_KITESURFER_getInstance(), ActivityType_ALPINE_MOUNTAINEER_getInstance(), ActivityType_ROCK_CLIMBER_getInstance(), ActivityType_ICE_CLIMBER_getInstance(), ActivityType_SPELUNKER_getInstance(), ActivityType_THRU_HIKER_getInstance(), ActivityType_CANYONEER_getInstance(), ActivityType_BACKCOUNTRY_SKIER_getInstance(), ActivityType_CDL_TRUCK_DRIVER_getInstance(), ActivityType_TRANSIT_OPERATOR_getInstance(), ActivityType_CRANE_OPERATOR_getInstance(), ActivityType_FORKLIFT_OPERATOR_getInstance(), ActivityType_RAILWAY_CONDUCTOR_getInstance(), ActivityType_HEAVY_EQUIPMENT_OPERATOR_getInstance(), ActivityType_LAB_RESEARCHER_getInstance(), ActivityType_HAM_RADIO_OPERATOR_getInstance(), ActivityType_ENVIRONMENTAL_FIELD_CREW_getInstance(), ActivityType_SOFTWARE_QA_ENGINEER_getInstance(), ActivityType_SOUND_ENGINEER_getInstance(), ActivityType_LAND_SURVEYOR_getInstance(), ActivityType_POWERLIFTER_getInstance(), ActivityType_TRAIL_RUNNER_getInstance(), ActivityType_TRIATHLETE_getInstance(), ActivityType_PHYSICAL_THERAPY_PATIENT_getInstance(), ActivityType_TRACK_AND_FIELD_THROWER_getInstance(), ActivityType_COMPETITIVE_CYCLIST_getInstance(), ActivityType_COMPETITIVE_SWIMMER_getInstance(), ActivityType_EQUESTRIAN_getInstance(), ActivityType_WORKING_DOG_HANDLER_getInstance(), ActivityType_FALCONER_getInstance(), ActivityType_BEEKEEPER_getInstance(), ActivityType_LIVESTOCK_HANDLER_getInstance(), ActivityType_TATTOO_APPRENTICE_getInstance(), ActivityType_TRADE_APPRENTICE_getInstance(), ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_getInstance(), ActivityType_WELDING_APPRENTICE_getInstance(), ActivityType_CULINARY_APPRENTICE_getInstance(), ActivityType_WALKER_getInstance(), ActivityType_RUNNER_getInstance(), ActivityType_RAFTER_getInstance(), ActivityType_GOLFER_getInstance(), ActivityType_DARTS_PLAYER_getInstance(), ActivityType_BASEBALL_PLAYER_getInstance(), ActivityType_BILLIARDS_PLAYER_getInstance(), ActivityType_ALPINE_SKIER_getInstance(), ActivityType_DOWNHILL_MOUNTAIN_BIKER_getInstance(), ActivityType_YOGA_PRACTITIONER_getInstance(), ActivityType_CARD_PLAYER_getInstance(), ActivityType_RACE_CAR_DRIVER_getInstance(), ActivityType_MOTORCYCLE_RIDER_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'STUDENT_PILOT':
        return ActivityType_STUDENT_PILOT_getInstance();
      case 'AIRLINE_TRANSPORT_PILOT':
        return ActivityType_AIRLINE_TRANSPORT_PILOT_getInstance();
      case 'FLIGHT_INSTRUCTOR':
        return ActivityType_FLIGHT_INSTRUCTOR_getInstance();
      case 'AIRCRAFT_MAINTENANCE_TECHNICIAN':
        return ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_getInstance();
      case 'DRONE_OPERATOR':
        return ActivityType_DRONE_OPERATOR_getInstance();
      case 'GLIDER_PILOT':
        return ActivityType_GLIDER_PILOT_getInstance();
      case 'HOT_AIR_BALLOON_PILOT':
        return ActivityType_HOT_AIR_BALLOON_PILOT_getInstance();
      case 'FLIGHT_SIMULATOR_OPERATOR':
        return ActivityType_FLIGHT_SIMULATOR_OPERATOR_getInstance();
      case 'ASTRONAUT':
        return ActivityType_ASTRONAUT_getInstance();
      case 'AEROBATIC_PILOT':
        return ActivityType_AEROBATIC_PILOT_getInstance();
      case 'PARACHUTE_RIGGER':
        return ActivityType_PARACHUTE_RIGGER_getInstance();
      case 'SKYDIVER':
        return ActivityType_SKYDIVER_getInstance();
      case 'PARAGLIDER':
        return ActivityType_PARAGLIDER_getInstance();
      case 'HANG_GLIDER':
        return ActivityType_HANG_GLIDER_getInstance();
      case 'BASE_JUMPER':
        return ActivityType_BASE_JUMPER_getInstance();
      case 'PARAMOTOR_PILOT':
        return ActivityType_PARAMOTOR_PILOT_getInstance();
      case 'SPEEDWING_FLYER':
        return ActivityType_SPEEDWING_FLYER_getInstance();
      case 'WINGSUIT_PILOT':
        return ActivityType_WINGSUIT_PILOT_getInstance();
      case 'INDOOR_SKYDIVING_COACH':
        return ActivityType_INDOOR_SKYDIVING_COACH_getInstance();
      case 'RECREATIONAL_SCUBA_DIVER':
        return ActivityType_RECREATIONAL_SCUBA_DIVER_getInstance();
      case 'TECHNICAL_DIVER':
        return ActivityType_TECHNICAL_DIVER_getInstance();
      case 'COMMERCIAL_DIVER':
        return ActivityType_COMMERCIAL_DIVER_getInstance();
      case 'SCIENTIFIC_RESEARCH_DIVER':
        return ActivityType_SCIENTIFIC_RESEARCH_DIVER_getInstance();
      case 'FREEDIVER':
        return ActivityType_FREEDIVER_getInstance();
      case 'PUBLIC_SAFETY_DIVER':
        return ActivityType_PUBLIC_SAFETY_DIVER_getInstance();
      case 'SPEARFISHING_DIVER':
        return ActivityType_SPEARFISHING_DIVER_getInstance();
      case 'UNDERWATER_PHOTOGRAPHER':
        return ActivityType_UNDERWATER_PHOTOGRAPHER_getInstance();
      case 'MERCHANT_MARINE':
        return ActivityType_MERCHANT_MARINE_getInstance();
      case 'SAILING_CAPTAIN':
        return ActivityType_SAILING_CAPTAIN_getInstance();
      case 'WHITEWATER_GUIDE':
        return ActivityType_WHITEWATER_GUIDE_getInstance();
      case 'LIFEGUARD':
        return ActivityType_LIFEGUARD_getInstance();
      case 'ROWING_ATHLETE':
        return ActivityType_ROWING_ATHLETE_getInstance();
      case 'SURFER':
        return ActivityType_SURFER_getInstance();
      case 'KITESURFER':
        return ActivityType_KITESURFER_getInstance();
      case 'ALPINE_MOUNTAINEER':
        return ActivityType_ALPINE_MOUNTAINEER_getInstance();
      case 'ROCK_CLIMBER':
        return ActivityType_ROCK_CLIMBER_getInstance();
      case 'ICE_CLIMBER':
        return ActivityType_ICE_CLIMBER_getInstance();
      case 'SPELUNKER':
        return ActivityType_SPELUNKER_getInstance();
      case 'THRU_HIKER':
        return ActivityType_THRU_HIKER_getInstance();
      case 'CANYONEER':
        return ActivityType_CANYONEER_getInstance();
      case 'BACKCOUNTRY_SKIER':
        return ActivityType_BACKCOUNTRY_SKIER_getInstance();
      case 'CDL_TRUCK_DRIVER':
        return ActivityType_CDL_TRUCK_DRIVER_getInstance();
      case 'TRANSIT_OPERATOR':
        return ActivityType_TRANSIT_OPERATOR_getInstance();
      case 'CRANE_OPERATOR':
        return ActivityType_CRANE_OPERATOR_getInstance();
      case 'FORKLIFT_OPERATOR':
        return ActivityType_FORKLIFT_OPERATOR_getInstance();
      case 'RAILWAY_CONDUCTOR':
        return ActivityType_RAILWAY_CONDUCTOR_getInstance();
      case 'HEAVY_EQUIPMENT_OPERATOR':
        return ActivityType_HEAVY_EQUIPMENT_OPERATOR_getInstance();
      case 'LAB_RESEARCHER':
        return ActivityType_LAB_RESEARCHER_getInstance();
      case 'HAM_RADIO_OPERATOR':
        return ActivityType_HAM_RADIO_OPERATOR_getInstance();
      case 'ENVIRONMENTAL_FIELD_CREW':
        return ActivityType_ENVIRONMENTAL_FIELD_CREW_getInstance();
      case 'SOFTWARE_QA_ENGINEER':
        return ActivityType_SOFTWARE_QA_ENGINEER_getInstance();
      case 'SOUND_ENGINEER':
        return ActivityType_SOUND_ENGINEER_getInstance();
      case 'LAND_SURVEYOR':
        return ActivityType_LAND_SURVEYOR_getInstance();
      case 'POWERLIFTER':
        return ActivityType_POWERLIFTER_getInstance();
      case 'TRAIL_RUNNER':
        return ActivityType_TRAIL_RUNNER_getInstance();
      case 'TRIATHLETE':
        return ActivityType_TRIATHLETE_getInstance();
      case 'PHYSICAL_THERAPY_PATIENT':
        return ActivityType_PHYSICAL_THERAPY_PATIENT_getInstance();
      case 'TRACK_AND_FIELD_THROWER':
        return ActivityType_TRACK_AND_FIELD_THROWER_getInstance();
      case 'COMPETITIVE_CYCLIST':
        return ActivityType_COMPETITIVE_CYCLIST_getInstance();
      case 'COMPETITIVE_SWIMMER':
        return ActivityType_COMPETITIVE_SWIMMER_getInstance();
      case 'EQUESTRIAN':
        return ActivityType_EQUESTRIAN_getInstance();
      case 'WORKING_DOG_HANDLER':
        return ActivityType_WORKING_DOG_HANDLER_getInstance();
      case 'FALCONER':
        return ActivityType_FALCONER_getInstance();
      case 'BEEKEEPER':
        return ActivityType_BEEKEEPER_getInstance();
      case 'LIVESTOCK_HANDLER':
        return ActivityType_LIVESTOCK_HANDLER_getInstance();
      case 'TATTOO_APPRENTICE':
        return ActivityType_TATTOO_APPRENTICE_getInstance();
      case 'TRADE_APPRENTICE':
        return ActivityType_TRADE_APPRENTICE_getInstance();
      case 'SCUBA_LIFE_SUPPORT_TECHNICIAN':
        return ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_getInstance();
      case 'WELDING_APPRENTICE':
        return ActivityType_WELDING_APPRENTICE_getInstance();
      case 'CULINARY_APPRENTICE':
        return ActivityType_CULINARY_APPRENTICE_getInstance();
      case 'WALKER':
        return ActivityType_WALKER_getInstance();
      case 'RUNNER':
        return ActivityType_RUNNER_getInstance();
      case 'RAFTER':
        return ActivityType_RAFTER_getInstance();
      case 'GOLFER':
        return ActivityType_GOLFER_getInstance();
      case 'DARTS_PLAYER':
        return ActivityType_DARTS_PLAYER_getInstance();
      case 'BASEBALL_PLAYER':
        return ActivityType_BASEBALL_PLAYER_getInstance();
      case 'BILLIARDS_PLAYER':
        return ActivityType_BILLIARDS_PLAYER_getInstance();
      case 'ALPINE_SKIER':
        return ActivityType_ALPINE_SKIER_getInstance();
      case 'DOWNHILL_MOUNTAIN_BIKER':
        return ActivityType_DOWNHILL_MOUNTAIN_BIKER_getInstance();
      case 'YOGA_PRACTITIONER':
        return ActivityType_YOGA_PRACTITIONER_getInstance();
      case 'CARD_PLAYER':
        return ActivityType_CARD_PLAYER_getInstance();
      case 'RACE_CAR_DRIVER':
        return ActivityType_RACE_CAR_DRIVER_getInstance();
      case 'MOTORCYCLE_RIDER':
        return ActivityType_MOTORCYCLE_RIDER_getInstance();
      default:
        ActivityType_initEntries();
        THROW_IAE('No enum constant com.universaliun.bitakore.common.domain.bitacora.ActivityType.' + value);
        break;
    }
  }
  var ActivityType_entriesInitialized;
  function ActivityType_initEntries() {
    if (ActivityType_entriesInitialized)
      return Unit_instance;
    ActivityType_entriesInitialized = true;
    ActivityType_STUDENT_PILOT_instance = new ActivityType('STUDENT_PILOT', 0, ActivityCategory_AVIATION_getInstance());
    ActivityType_AIRLINE_TRANSPORT_PILOT_instance = new ActivityType('AIRLINE_TRANSPORT_PILOT', 1, ActivityCategory_AVIATION_getInstance());
    ActivityType_FLIGHT_INSTRUCTOR_instance = new ActivityType('FLIGHT_INSTRUCTOR', 2, ActivityCategory_AVIATION_getInstance());
    ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_instance = new ActivityType('AIRCRAFT_MAINTENANCE_TECHNICIAN', 3, ActivityCategory_AVIATION_getInstance());
    ActivityType_DRONE_OPERATOR_instance = new ActivityType('DRONE_OPERATOR', 4, ActivityCategory_AVIATION_getInstance());
    ActivityType_GLIDER_PILOT_instance = new ActivityType('GLIDER_PILOT', 5, ActivityCategory_AVIATION_getInstance(), false);
    ActivityType_HOT_AIR_BALLOON_PILOT_instance = new ActivityType('HOT_AIR_BALLOON_PILOT', 6, ActivityCategory_AVIATION_getInstance());
    ActivityType_FLIGHT_SIMULATOR_OPERATOR_instance = new ActivityType('FLIGHT_SIMULATOR_OPERATOR', 7, ActivityCategory_AVIATION_getInstance());
    ActivityType_ASTRONAUT_instance = new ActivityType('ASTRONAUT', 8, ActivityCategory_AVIATION_getInstance());
    ActivityType_AEROBATIC_PILOT_instance = new ActivityType('AEROBATIC_PILOT', 9, ActivityCategory_AVIATION_getInstance());
    ActivityType_PARACHUTE_RIGGER_instance = new ActivityType('PARACHUTE_RIGGER', 10, ActivityCategory_AVIATION_getInstance());
    ActivityType_SKYDIVER_instance = new ActivityType('SKYDIVER', 11, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_PARAGLIDER_instance = new ActivityType('PARAGLIDER', 12, ActivityCategory_AIR_SPORTS_getInstance(), false);
    ActivityType_HANG_GLIDER_instance = new ActivityType('HANG_GLIDER', 13, ActivityCategory_AIR_SPORTS_getInstance(), false);
    ActivityType_BASE_JUMPER_instance = new ActivityType('BASE_JUMPER', 14, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_PARAMOTOR_PILOT_instance = new ActivityType('PARAMOTOR_PILOT', 15, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_SPEEDWING_FLYER_instance = new ActivityType('SPEEDWING_FLYER', 16, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_WINGSUIT_PILOT_instance = new ActivityType('WINGSUIT_PILOT', 17, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_INDOOR_SKYDIVING_COACH_instance = new ActivityType('INDOOR_SKYDIVING_COACH', 18, ActivityCategory_AIR_SPORTS_getInstance());
    ActivityType_RECREATIONAL_SCUBA_DIVER_instance = new ActivityType('RECREATIONAL_SCUBA_DIVER', 19, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_TECHNICAL_DIVER_instance = new ActivityType('TECHNICAL_DIVER', 20, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_COMMERCIAL_DIVER_instance = new ActivityType('COMMERCIAL_DIVER', 21, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_SCIENTIFIC_RESEARCH_DIVER_instance = new ActivityType('SCIENTIFIC_RESEARCH_DIVER', 22, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_FREEDIVER_instance = new ActivityType('FREEDIVER', 23, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_PUBLIC_SAFETY_DIVER_instance = new ActivityType('PUBLIC_SAFETY_DIVER', 24, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_SPEARFISHING_DIVER_instance = new ActivityType('SPEARFISHING_DIVER', 25, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_UNDERWATER_PHOTOGRAPHER_instance = new ActivityType('UNDERWATER_PHOTOGRAPHER', 26, ActivityCategory_UNDERWATER_getInstance());
    ActivityType_MERCHANT_MARINE_instance = new ActivityType('MERCHANT_MARINE', 27, ActivityCategory_MARITIME_getInstance());
    ActivityType_SAILING_CAPTAIN_instance = new ActivityType('SAILING_CAPTAIN', 28, ActivityCategory_MARITIME_getInstance());
    ActivityType_WHITEWATER_GUIDE_instance = new ActivityType('WHITEWATER_GUIDE', 29, ActivityCategory_MARITIME_getInstance());
    ActivityType_LIFEGUARD_instance = new ActivityType('LIFEGUARD', 30, ActivityCategory_MARITIME_getInstance());
    ActivityType_ROWING_ATHLETE_instance = new ActivityType('ROWING_ATHLETE', 31, ActivityCategory_MARITIME_getInstance());
    ActivityType_SURFER_instance = new ActivityType('SURFER', 32, ActivityCategory_MARITIME_getInstance());
    ActivityType_KITESURFER_instance = new ActivityType('KITESURFER', 33, ActivityCategory_MARITIME_getInstance());
    ActivityType_ALPINE_MOUNTAINEER_instance = new ActivityType('ALPINE_MOUNTAINEER', 34, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_ROCK_CLIMBER_instance = new ActivityType('ROCK_CLIMBER', 35, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_ICE_CLIMBER_instance = new ActivityType('ICE_CLIMBER', 36, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_SPELUNKER_instance = new ActivityType('SPELUNKER', 37, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_THRU_HIKER_instance = new ActivityType('THRU_HIKER', 38, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_CANYONEER_instance = new ActivityType('CANYONEER', 39, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_BACKCOUNTRY_SKIER_instance = new ActivityType('BACKCOUNTRY_SKIER', 40, ActivityCategory_MOUNTAIN_getInstance());
    ActivityType_CDL_TRUCK_DRIVER_instance = new ActivityType('CDL_TRUCK_DRIVER', 41, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_TRANSIT_OPERATOR_instance = new ActivityType('TRANSIT_OPERATOR', 42, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_CRANE_OPERATOR_instance = new ActivityType('CRANE_OPERATOR', 43, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_FORKLIFT_OPERATOR_instance = new ActivityType('FORKLIFT_OPERATOR', 44, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_RAILWAY_CONDUCTOR_instance = new ActivityType('RAILWAY_CONDUCTOR', 45, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_HEAVY_EQUIPMENT_OPERATOR_instance = new ActivityType('HEAVY_EQUIPMENT_OPERATOR', 46, ActivityCategory_HEAVY_MACHINERY_getInstance());
    ActivityType_LAB_RESEARCHER_instance = new ActivityType('LAB_RESEARCHER', 47, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_HAM_RADIO_OPERATOR_instance = new ActivityType('HAM_RADIO_OPERATOR', 48, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_ENVIRONMENTAL_FIELD_CREW_instance = new ActivityType('ENVIRONMENTAL_FIELD_CREW', 49, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_SOFTWARE_QA_ENGINEER_instance = new ActivityType('SOFTWARE_QA_ENGINEER', 50, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_SOUND_ENGINEER_instance = new ActivityType('SOUND_ENGINEER', 51, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_LAND_SURVEYOR_instance = new ActivityType('LAND_SURVEYOR', 52, ActivityCategory_TECHNICAL_TRADES_getInstance());
    ActivityType_POWERLIFTER_instance = new ActivityType('POWERLIFTER', 53, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_TRAIL_RUNNER_instance = new ActivityType('TRAIL_RUNNER', 54, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_TRIATHLETE_instance = new ActivityType('TRIATHLETE', 55, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_PHYSICAL_THERAPY_PATIENT_instance = new ActivityType('PHYSICAL_THERAPY_PATIENT', 56, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_TRACK_AND_FIELD_THROWER_instance = new ActivityType('TRACK_AND_FIELD_THROWER', 57, ActivityCategory_ATHLETICS_getInstance(), false);
    ActivityType_COMPETITIVE_CYCLIST_instance = new ActivityType('COMPETITIVE_CYCLIST', 58, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_COMPETITIVE_SWIMMER_instance = new ActivityType('COMPETITIVE_SWIMMER', 59, ActivityCategory_ATHLETICS_getInstance());
    ActivityType_EQUESTRIAN_instance = new ActivityType('EQUESTRIAN', 60, ActivityCategory_ANIMAL_HANDLING_getInstance());
    ActivityType_WORKING_DOG_HANDLER_instance = new ActivityType('WORKING_DOG_HANDLER', 61, ActivityCategory_ANIMAL_HANDLING_getInstance());
    ActivityType_FALCONER_instance = new ActivityType('FALCONER', 62, ActivityCategory_ANIMAL_HANDLING_getInstance());
    ActivityType_BEEKEEPER_instance = new ActivityType('BEEKEEPER', 63, ActivityCategory_ANIMAL_HANDLING_getInstance());
    ActivityType_LIVESTOCK_HANDLER_instance = new ActivityType('LIVESTOCK_HANDLER', 64, ActivityCategory_ANIMAL_HANDLING_getInstance());
    ActivityType_TATTOO_APPRENTICE_instance = new ActivityType('TATTOO_APPRENTICE', 65, ActivityCategory_VOCATIONAL_getInstance());
    ActivityType_TRADE_APPRENTICE_instance = new ActivityType('TRADE_APPRENTICE', 66, ActivityCategory_VOCATIONAL_getInstance());
    ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_instance = new ActivityType('SCUBA_LIFE_SUPPORT_TECHNICIAN', 67, ActivityCategory_VOCATIONAL_getInstance());
    ActivityType_WELDING_APPRENTICE_instance = new ActivityType('WELDING_APPRENTICE', 68, ActivityCategory_VOCATIONAL_getInstance());
    ActivityType_CULINARY_APPRENTICE_instance = new ActivityType('CULINARY_APPRENTICE', 69, ActivityCategory_VOCATIONAL_getInstance());
    ActivityType_WALKER_instance = new ActivityType('WALKER', 70, ActivityCategory_ATHLETICS_getInstance(), false);
    ActivityType_RUNNER_instance = new ActivityType('RUNNER', 71, ActivityCategory_ATHLETICS_getInstance(), false);
    ActivityType_RAFTER_instance = new ActivityType('RAFTER', 72, ActivityCategory_MARITIME_getInstance(), false);
    ActivityType_GOLFER_instance = new ActivityType('GOLFER', 73, ActivityCategory_RECREATIONAL_SPORTS_getInstance(), false);
    ActivityType_DARTS_PLAYER_instance = new ActivityType('DARTS_PLAYER', 74, ActivityCategory_RECREATIONAL_SPORTS_getInstance(), false);
    ActivityType_BASEBALL_PLAYER_instance = new ActivityType('BASEBALL_PLAYER', 75, ActivityCategory_RECREATIONAL_SPORTS_getInstance(), false);
    ActivityType_BILLIARDS_PLAYER_instance = new ActivityType('BILLIARDS_PLAYER', 76, ActivityCategory_RECREATIONAL_SPORTS_getInstance(), false);
    ActivityType_ALPINE_SKIER_instance = new ActivityType('ALPINE_SKIER', 77, ActivityCategory_MOUNTAIN_getInstance(), false);
    ActivityType_DOWNHILL_MOUNTAIN_BIKER_instance = new ActivityType('DOWNHILL_MOUNTAIN_BIKER', 78, ActivityCategory_MOUNTAIN_getInstance(), false);
    ActivityType_YOGA_PRACTITIONER_instance = new ActivityType('YOGA_PRACTITIONER', 79, ActivityCategory_ATHLETICS_getInstance(), false);
    ActivityType_CARD_PLAYER_instance = new ActivityType('CARD_PLAYER', 80, ActivityCategory_TABLETOP_GAMES_getInstance(), false);
    ActivityType_RACE_CAR_DRIVER_instance = new ActivityType('RACE_CAR_DRIVER', 81, ActivityCategory_MOTORSPORTS_getInstance(), false);
    ActivityType_MOTORCYCLE_RIDER_instance = new ActivityType('MOTORCYCLE_RIDER', 82, ActivityCategory_MOTORSPORTS_getInstance(), false);
  }
  function ActivityType(name, ordinal, category, requiresVerification) {
    requiresVerification = requiresVerification === VOID ? true : requiresVerification;
    Enum.call(this, name, ordinal);
    this.cj_1 = category;
    this.dj_1 = requiresVerification;
  }
  function ActivityType_STUDENT_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_STUDENT_PILOT_instance;
  }
  function ActivityType_AIRLINE_TRANSPORT_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_AIRLINE_TRANSPORT_PILOT_instance;
  }
  function ActivityType_FLIGHT_INSTRUCTOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_FLIGHT_INSTRUCTOR_instance;
  }
  function ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_getInstance() {
    ActivityType_initEntries();
    return ActivityType_AIRCRAFT_MAINTENANCE_TECHNICIAN_instance;
  }
  function ActivityType_DRONE_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_DRONE_OPERATOR_instance;
  }
  function ActivityType_GLIDER_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_GLIDER_PILOT_instance;
  }
  function ActivityType_HOT_AIR_BALLOON_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_HOT_AIR_BALLOON_PILOT_instance;
  }
  function ActivityType_FLIGHT_SIMULATOR_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_FLIGHT_SIMULATOR_OPERATOR_instance;
  }
  function ActivityType_ASTRONAUT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ASTRONAUT_instance;
  }
  function ActivityType_AEROBATIC_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_AEROBATIC_PILOT_instance;
  }
  function ActivityType_PARACHUTE_RIGGER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_PARACHUTE_RIGGER_instance;
  }
  function ActivityType_SKYDIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SKYDIVER_instance;
  }
  function ActivityType_PARAGLIDER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_PARAGLIDER_instance;
  }
  function ActivityType_HANG_GLIDER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_HANG_GLIDER_instance;
  }
  function ActivityType_BASE_JUMPER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_BASE_JUMPER_instance;
  }
  function ActivityType_PARAMOTOR_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_PARAMOTOR_PILOT_instance;
  }
  function ActivityType_SPEEDWING_FLYER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SPEEDWING_FLYER_instance;
  }
  function ActivityType_WINGSUIT_PILOT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_WINGSUIT_PILOT_instance;
  }
  function ActivityType_INDOOR_SKYDIVING_COACH_getInstance() {
    ActivityType_initEntries();
    return ActivityType_INDOOR_SKYDIVING_COACH_instance;
  }
  function ActivityType_RECREATIONAL_SCUBA_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_RECREATIONAL_SCUBA_DIVER_instance;
  }
  function ActivityType_TECHNICAL_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TECHNICAL_DIVER_instance;
  }
  function ActivityType_COMMERCIAL_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_COMMERCIAL_DIVER_instance;
  }
  function ActivityType_SCIENTIFIC_RESEARCH_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SCIENTIFIC_RESEARCH_DIVER_instance;
  }
  function ActivityType_FREEDIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_FREEDIVER_instance;
  }
  function ActivityType_PUBLIC_SAFETY_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_PUBLIC_SAFETY_DIVER_instance;
  }
  function ActivityType_SPEARFISHING_DIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SPEARFISHING_DIVER_instance;
  }
  function ActivityType_UNDERWATER_PHOTOGRAPHER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_UNDERWATER_PHOTOGRAPHER_instance;
  }
  function ActivityType_MERCHANT_MARINE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_MERCHANT_MARINE_instance;
  }
  function ActivityType_SAILING_CAPTAIN_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SAILING_CAPTAIN_instance;
  }
  function ActivityType_WHITEWATER_GUIDE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_WHITEWATER_GUIDE_instance;
  }
  function ActivityType_LIFEGUARD_getInstance() {
    ActivityType_initEntries();
    return ActivityType_LIFEGUARD_instance;
  }
  function ActivityType_ROWING_ATHLETE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ROWING_ATHLETE_instance;
  }
  function ActivityType_SURFER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SURFER_instance;
  }
  function ActivityType_KITESURFER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_KITESURFER_instance;
  }
  function ActivityType_ALPINE_MOUNTAINEER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ALPINE_MOUNTAINEER_instance;
  }
  function ActivityType_ROCK_CLIMBER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ROCK_CLIMBER_instance;
  }
  function ActivityType_ICE_CLIMBER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ICE_CLIMBER_instance;
  }
  function ActivityType_SPELUNKER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SPELUNKER_instance;
  }
  function ActivityType_THRU_HIKER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_THRU_HIKER_instance;
  }
  function ActivityType_CANYONEER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_CANYONEER_instance;
  }
  function ActivityType_BACKCOUNTRY_SKIER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_BACKCOUNTRY_SKIER_instance;
  }
  function ActivityType_CDL_TRUCK_DRIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_CDL_TRUCK_DRIVER_instance;
  }
  function ActivityType_TRANSIT_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TRANSIT_OPERATOR_instance;
  }
  function ActivityType_CRANE_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_CRANE_OPERATOR_instance;
  }
  function ActivityType_FORKLIFT_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_FORKLIFT_OPERATOR_instance;
  }
  function ActivityType_RAILWAY_CONDUCTOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_RAILWAY_CONDUCTOR_instance;
  }
  function ActivityType_HEAVY_EQUIPMENT_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_HEAVY_EQUIPMENT_OPERATOR_instance;
  }
  function ActivityType_LAB_RESEARCHER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_LAB_RESEARCHER_instance;
  }
  function ActivityType_HAM_RADIO_OPERATOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_HAM_RADIO_OPERATOR_instance;
  }
  function ActivityType_ENVIRONMENTAL_FIELD_CREW_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ENVIRONMENTAL_FIELD_CREW_instance;
  }
  function ActivityType_SOFTWARE_QA_ENGINEER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SOFTWARE_QA_ENGINEER_instance;
  }
  function ActivityType_SOUND_ENGINEER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SOUND_ENGINEER_instance;
  }
  function ActivityType_LAND_SURVEYOR_getInstance() {
    ActivityType_initEntries();
    return ActivityType_LAND_SURVEYOR_instance;
  }
  function ActivityType_POWERLIFTER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_POWERLIFTER_instance;
  }
  function ActivityType_TRAIL_RUNNER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TRAIL_RUNNER_instance;
  }
  function ActivityType_TRIATHLETE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TRIATHLETE_instance;
  }
  function ActivityType_PHYSICAL_THERAPY_PATIENT_getInstance() {
    ActivityType_initEntries();
    return ActivityType_PHYSICAL_THERAPY_PATIENT_instance;
  }
  function ActivityType_TRACK_AND_FIELD_THROWER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TRACK_AND_FIELD_THROWER_instance;
  }
  function ActivityType_COMPETITIVE_CYCLIST_getInstance() {
    ActivityType_initEntries();
    return ActivityType_COMPETITIVE_CYCLIST_instance;
  }
  function ActivityType_COMPETITIVE_SWIMMER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_COMPETITIVE_SWIMMER_instance;
  }
  function ActivityType_EQUESTRIAN_getInstance() {
    ActivityType_initEntries();
    return ActivityType_EQUESTRIAN_instance;
  }
  function ActivityType_WORKING_DOG_HANDLER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_WORKING_DOG_HANDLER_instance;
  }
  function ActivityType_FALCONER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_FALCONER_instance;
  }
  function ActivityType_BEEKEEPER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_BEEKEEPER_instance;
  }
  function ActivityType_LIVESTOCK_HANDLER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_LIVESTOCK_HANDLER_instance;
  }
  function ActivityType_TATTOO_APPRENTICE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TATTOO_APPRENTICE_instance;
  }
  function ActivityType_TRADE_APPRENTICE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_TRADE_APPRENTICE_instance;
  }
  function ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_getInstance() {
    ActivityType_initEntries();
    return ActivityType_SCUBA_LIFE_SUPPORT_TECHNICIAN_instance;
  }
  function ActivityType_WELDING_APPRENTICE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_WELDING_APPRENTICE_instance;
  }
  function ActivityType_CULINARY_APPRENTICE_getInstance() {
    ActivityType_initEntries();
    return ActivityType_CULINARY_APPRENTICE_instance;
  }
  function ActivityType_WALKER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_WALKER_instance;
  }
  function ActivityType_RUNNER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_RUNNER_instance;
  }
  function ActivityType_RAFTER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_RAFTER_instance;
  }
  function ActivityType_GOLFER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_GOLFER_instance;
  }
  function ActivityType_DARTS_PLAYER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_DARTS_PLAYER_instance;
  }
  function ActivityType_BASEBALL_PLAYER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_BASEBALL_PLAYER_instance;
  }
  function ActivityType_BILLIARDS_PLAYER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_BILLIARDS_PLAYER_instance;
  }
  function ActivityType_ALPINE_SKIER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_ALPINE_SKIER_instance;
  }
  function ActivityType_DOWNHILL_MOUNTAIN_BIKER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_DOWNHILL_MOUNTAIN_BIKER_instance;
  }
  function ActivityType_YOGA_PRACTITIONER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_YOGA_PRACTITIONER_instance;
  }
  function ActivityType_CARD_PLAYER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_CARD_PLAYER_instance;
  }
  function ActivityType_RACE_CAR_DRIVER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_RACE_CAR_DRIVER_instance;
  }
  function ActivityType_MOTORCYCLE_RIDER_getInstance() {
    ActivityType_initEntries();
    return ActivityType_MOTORCYCLE_RIDER_instance;
  }
  var BitacoraEntryStatus_PENDING_instance;
  var BitacoraEntryStatus_VERIFIED_instance;
  var BitacoraEntryStatus_REJECTED_instance;
  function values_0() {
    return [BitacoraEntryStatus_PENDING_getInstance(), BitacoraEntryStatus_VERIFIED_getInstance(), BitacoraEntryStatus_REJECTED_getInstance()];
  }
  var BitacoraEntryStatus_entriesInitialized;
  function BitacoraEntryStatus_initEntries() {
    if (BitacoraEntryStatus_entriesInitialized)
      return Unit_instance;
    BitacoraEntryStatus_entriesInitialized = true;
    BitacoraEntryStatus_PENDING_instance = new BitacoraEntryStatus('PENDING', 0);
    BitacoraEntryStatus_VERIFIED_instance = new BitacoraEntryStatus('VERIFIED', 1);
    BitacoraEntryStatus_REJECTED_instance = new BitacoraEntryStatus('REJECTED', 2);
  }
  function BitacoraEntryStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BitacoraEntryStatus_PENDING_getInstance() {
    BitacoraEntryStatus_initEntries();
    return BitacoraEntryStatus_PENDING_instance;
  }
  function BitacoraEntryStatus_VERIFIED_getInstance() {
    BitacoraEntryStatus_initEntries();
    return BitacoraEntryStatus_VERIFIED_instance;
  }
  function BitacoraEntryStatus_REJECTED_getInstance() {
    BitacoraEntryStatus_initEntries();
    return BitacoraEntryStatus_REJECTED_instance;
  }
  var ClaimDecision_APPROVED_instance;
  var ClaimDecision_REJECTED_instance;
  function values_1() {
    return [ClaimDecision_APPROVED_getInstance(), ClaimDecision_REJECTED_getInstance()];
  }
  var ClaimDecision_entriesInitialized;
  function ClaimDecision_initEntries() {
    if (ClaimDecision_entriesInitialized)
      return Unit_instance;
    ClaimDecision_entriesInitialized = true;
    ClaimDecision_APPROVED_instance = new ClaimDecision('APPROVED', 0);
    ClaimDecision_REJECTED_instance = new ClaimDecision('REJECTED', 1);
  }
  function ClaimDecision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClaimDecision_APPROVED_getInstance() {
    ClaimDecision_initEntries();
    return ClaimDecision_APPROVED_instance;
  }
  function ClaimDecision_REJECTED_getInstance() {
    ClaimDecision_initEntries();
    return ClaimDecision_REJECTED_instance;
  }
  var VerificationDecision_APPROVED_instance;
  var VerificationDecision_REJECTED_instance;
  function values_2() {
    return [VerificationDecision_APPROVED_getInstance(), VerificationDecision_REJECTED_getInstance()];
  }
  var VerificationDecision_entriesInitialized;
  function VerificationDecision_initEntries() {
    if (VerificationDecision_entriesInitialized)
      return Unit_instance;
    VerificationDecision_entriesInitialized = true;
    VerificationDecision_APPROVED_instance = new VerificationDecision('APPROVED', 0);
    VerificationDecision_REJECTED_instance = new VerificationDecision('REJECTED', 1);
  }
  function VerificationDecision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function VerificationDecision_APPROVED_getInstance() {
    VerificationDecision_initEntries();
    return VerificationDecision_APPROVED_instance;
  }
  function VerificationDecision_REJECTED_getInstance() {
    VerificationDecision_initEntries();
    return VerificationDecision_REJECTED_instance;
  }
  var VisibilityDecision_APPROVED_instance;
  var VisibilityDecision_REJECTED_instance;
  function values_3() {
    return [VisibilityDecision_APPROVED_getInstance(), VisibilityDecision_REJECTED_getInstance()];
  }
  var VisibilityDecision_entriesInitialized;
  function VisibilityDecision_initEntries() {
    if (VisibilityDecision_entriesInitialized)
      return Unit_instance;
    VisibilityDecision_entriesInitialized = true;
    VisibilityDecision_APPROVED_instance = new VisibilityDecision('APPROVED', 0);
    VisibilityDecision_REJECTED_instance = new VisibilityDecision('REJECTED', 1);
  }
  function VisibilityDecision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function VisibilityDecision_APPROVED_getInstance() {
    VisibilityDecision_initEntries();
    return VisibilityDecision_APPROVED_instance;
  }
  function VisibilityDecision_REJECTED_getInstance() {
    VisibilityDecision_initEntries();
    return VisibilityDecision_REJECTED_instance;
  }
  var CompanyMemberRole_COMPANY_ADMIN_instance;
  var CompanyMemberRole_ACTIVITY_VERIFIER_instance;
  function values_4() {
    return [CompanyMemberRole_COMPANY_ADMIN_getInstance(), CompanyMemberRole_ACTIVITY_VERIFIER_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'COMPANY_ADMIN':
        return CompanyMemberRole_COMPANY_ADMIN_getInstance();
      case 'ACTIVITY_VERIFIER':
        return CompanyMemberRole_ACTIVITY_VERIFIER_getInstance();
      default:
        CompanyMemberRole_initEntries();
        THROW_IAE('No enum constant com.universaliun.bitakore.common.domain.company.CompanyMemberRole.' + value);
        break;
    }
  }
  var CompanyMemberRole_entriesInitialized;
  function CompanyMemberRole_initEntries() {
    if (CompanyMemberRole_entriesInitialized)
      return Unit_instance;
    CompanyMemberRole_entriesInitialized = true;
    CompanyMemberRole_COMPANY_ADMIN_instance = new CompanyMemberRole('COMPANY_ADMIN', 0);
    CompanyMemberRole_ACTIVITY_VERIFIER_instance = new CompanyMemberRole('ACTIVITY_VERIFIER', 1);
  }
  function CompanyMemberRole(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompanyMemberRole_COMPANY_ADMIN_getInstance() {
    CompanyMemberRole_initEntries();
    return CompanyMemberRole_COMPANY_ADMIN_instance;
  }
  function CompanyMemberRole_ACTIVITY_VERIFIER_getInstance() {
    CompanyMemberRole_initEntries();
    return CompanyMemberRole_ACTIVITY_VERIFIER_instance;
  }
  var CompanyType_CERTIFICATION_ISSUER_instance;
  var CompanyType_ACTIVITY_CENTER_instance;
  var CompanyType_MARKETER_instance;
  function values_5() {
    return [CompanyType_CERTIFICATION_ISSUER_getInstance(), CompanyType_ACTIVITY_CENTER_getInstance(), CompanyType_MARKETER_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'CERTIFICATION_ISSUER':
        return CompanyType_CERTIFICATION_ISSUER_getInstance();
      case 'ACTIVITY_CENTER':
        return CompanyType_ACTIVITY_CENTER_getInstance();
      case 'MARKETER':
        return CompanyType_MARKETER_getInstance();
      default:
        CompanyType_initEntries();
        THROW_IAE('No enum constant com.universaliun.bitakore.common.domain.company.CompanyType.' + value);
        break;
    }
  }
  var CompanyType_entriesInitialized;
  function CompanyType_initEntries() {
    if (CompanyType_entriesInitialized)
      return Unit_instance;
    CompanyType_entriesInitialized = true;
    CompanyType_CERTIFICATION_ISSUER_instance = new CompanyType('CERTIFICATION_ISSUER', 0);
    CompanyType_ACTIVITY_CENTER_instance = new CompanyType('ACTIVITY_CENTER', 1);
    CompanyType_MARKETER_instance = new CompanyType('MARKETER', 2);
  }
  function CompanyType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompanyType_CERTIFICATION_ISSUER_getInstance() {
    CompanyType_initEntries();
    return CompanyType_CERTIFICATION_ISSUER_instance;
  }
  function CompanyType_ACTIVITY_CENTER_getInstance() {
    CompanyType_initEntries();
    return CompanyType_ACTIVITY_CENTER_instance;
  }
  function CompanyType_MARKETER_getInstance() {
    CompanyType_initEntries();
    return CompanyType_MARKETER_instance;
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = valueOf;
  _.$_$.b = values;
  _.$_$.c = values_0;
  _.$_$.d = values_1;
  _.$_$.e = values_2;
  _.$_$.f = values_3;
  _.$_$.g = valueOf_0;
  _.$_$.h = values_4;
  _.$_$.i = valueOf_1;
  _.$_$.j = values_5;
  _.$_$.k = ActivityCategory_AIR_SPORTS_getInstance;
  _.$_$.l = ActivityCategory_ANIMAL_HANDLING_getInstance;
  _.$_$.m = ActivityCategory_ATHLETICS_getInstance;
  _.$_$.n = ActivityCategory_AVIATION_getInstance;
  _.$_$.o = ActivityCategory_HEAVY_MACHINERY_getInstance;
  _.$_$.p = ActivityCategory_MARITIME_getInstance;
  _.$_$.q = ActivityCategory_MOUNTAIN_getInstance;
  _.$_$.r = ActivityCategory_TECHNICAL_TRADES_getInstance;
  _.$_$.s = ActivityCategory_UNDERWATER_getInstance;
  _.$_$.t = ActivityCategory_VOCATIONAL_getInstance;
  _.$_$.u = ClaimDecision_APPROVED_getInstance;
  _.$_$.v = ClaimDecision_REJECTED_getInstance;
  _.$_$.w = VerificationDecision_APPROVED_getInstance;
  _.$_$.x = VerificationDecision_REJECTED_getInstance;
  _.$_$.y = VisibilityDecision_APPROVED_getInstance;
  _.$_$.z = VisibilityDecision_REJECTED_getInstance;
  _.$_$.a1 = CompanyMemberRole_ACTIVITY_VERIFIER_getInstance;
  _.$_$.b1 = CompanyMemberRole_COMPANY_ADMIN_getInstance;
  _.$_$.c1 = CompanyType_ACTIVITY_CENTER_getInstance;
  _.$_$.d1 = CompanyType_MARKETER_getInstance;
  //endregion
  return _;
}));

